import React from "react";
import FooterOne from "../common/footer/FooterOne";
import HeaderFour from "../common/header/HeaderFour";
import SEO from "../common/SEO";
import CtaLayoutOne from "../component/cta/CtaLayoutOne";
import AboutProp from "../component/casestudy/AboutProp";
import ColorSwitcher from "../elements/switcher/ColorSwitcher";
import AboutFour from "../component/about/AboutFour";
import ChatbotTwo from "./ChatbotTwo";

const AboutUs = () => {
  return (
    <>
      <SEO />
      <ColorSwitcher />
      <main className="main-wrapper">
        <HeaderFour />

        <AboutFour />
        {/* <AboutFive /> */}
        <div className=" case-study-page-area">
          <div className="container">
            <AboutProp />
          </div>
        </div>
        {/* <ProcessOne /> */}

        <CtaLayoutOne />
        <FooterOne parentClass="" />
        <ChatbotTwo />
      </main>
    </>
  );
};

export default AboutUs;
